class SizeGuideUnitToggle extends HTMLElement {
  constructor() {
    super();
    this.buttons = Array.from(this.querySelectorAll('[data-unit]'));
    this.table = null;

    const wrapper = document.getElementById('guide-des-tailles');
    if (wrapper) this.table = wrapper.querySelector('table') || (wrapper.tagName === 'TABLE' ? wrapper : null);

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.setUnit(button.dataset.unit));
    });

    this.setUnit('in');
  }

  setUnit(unit) {
    if (!this.table) return;

    this.buttons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.unit === unit);
    });

    const cells = this.table.querySelectorAll('tbody tr td:not(:first-child)');
    cells.forEach((cell) => {
      if (!cell.dataset.cm) {
        const raw = parseFloat(cell.textContent.trim().replace(',', '.'));
        if (isNaN(raw)) return;
        cell.dataset.cm = raw;
      }

      const cm = parseFloat(cell.dataset.cm);
      if (isNaN(cm)) return;

      cell.textContent = unit === 'in' ? (cm / 2.54).toFixed(1) : cm.toString();
    });
  }
}

if (!customElements.get('size-guide-unit-toggle')) {
  customElements.define('size-guide-unit-toggle', SizeGuideUnitToggle);
}
